import { skipToken } from "@reduxjs/toolkit/query";

import {
  useGetJobQuery,
  useGetTalentInviteSuggestionsQuery,
} from "@js/apps/jobs/api";
import { usePollingJobMatchingStatus } from "@js/apps/jobs/hooks/polling-job-matching-status";
import { useQueryParams } from "@js/hooks";
import { useIdParam } from "@js/hooks/use-id-param";

export const useGetTalentInviteSuggestionsWithSmartMatching = () => {
  const id = useIdParam();
  const { page = 1 } = useQueryParams();
  const { data: job, isLoading: isJobLoading } = useGetJobQuery(
    id ? { id } : skipToken,
  );
  const totalBidsCount = job?.bids_count.total_bids_count || 0;
  const totalInterviewingAndActiveBidsCount =
    job?.bids_count?.interviewing_and_active_bids_count || 0;

  const { isSmartMatchingLoading, analyzingProfilesCount } =
    usePollingJobMatchingStatus({
      jobId: id,
    });

  const shouldWaitForSuggestions = !job || isSmartMatchingLoading;

  const {
    data: talentInviteSuggestions,
    isLoading: isLoadingTalentInviteSuggestions,
  } = useGetTalentInviteSuggestionsQuery(
    id ? { jobId: id, page: page ? +page : undefined } : skipToken,
    { skip: shouldWaitForSuggestions },
  );

  const isLoadingSuggestions =
    isSmartMatchingLoading || isJobLoading || isLoadingTalentInviteSuggestions;

  return {
    talentInviteSuggestions: talentInviteSuggestions?.results || [],
    inviteSuggestionsCount: talentInviteSuggestions?.count || 0,
    isLoadingSuggestions,
    totalBidsCount,
    totalInterviewingAndActiveBidsCount,
    job,
    analyzingProfilesCount,
    jobId: id,
    page,
  };
};
